import React, { useState } from "react";
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import Main from './pages/Main';
import Traders from './pages/Traders';
import Production from './pages/Production';
import Archive from './pages/Archive';
import Warehouse from './pages/Warehouse';
import Clients from './pages/Clients';
import Users from './pages/Users';
import Orders from './pages/Orders';
import OrderManage from './pages/OrderManage';
import FilesChecking from './pages/FilesChecking';
import Invoices from './pages/Invoices';
import Header from './components/Header';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import config from './config/default.json';
import { Alert, Snackbar, Grid, Grow, Autocomplete, Button } from '@mui/material';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { plPL } from '@mui/x-data-grid';
import { plPL as coreplPL } from '@mui/material/locale';
import MainContent from "./components/MainContent";
import { Box } from "@mui/system";

export const flattenObj = (ob) => {

  // The object which contains the
  // final result
  let result = {};

  // loop through the object "ob"
  for (const i in ob) {

    // We check the type of the i using
    // typeof() function and recursively
    // call the function again
    if ((typeof ob[i]) === 'object' && !Array.isArray(ob[i])) {
      const temp = flattenObj(ob[i]);
      for (const j in temp) {

        // Store temp in result
        result[i + '.' + j] = temp[j];
      }
    }
    // Else store ob[i] in result directly
    else {
      result[i] = ob[i];
    }
  }
  return result;
};

export const unflattenObject = obj =>
  Object.keys(obj).reduce((res, k) => {
    //console.log({ ...obj }, k, { ...res })
    k.split('.').reduce(
      (acc, e, i, keys) =>
        acc[e] ||
        (acc[e] = isNaN(Number(keys[i + 1]))
          ? keys.length - 1 === i
            ? obj[k]
            : {}
          : []),
      res
    );
    return res;
  }, {});

export const query = async (path, method, body, alert = true, contentType = 'application/json', json = true) => {
  console.log(new URL(window.location.href))
  return new Promise(prom => {
    fetch(config.apiPath + path, {
      'method': method,
      headers: {
        'Content-Type': contentType,
        'Authorization': `Bearer ${new URL(window.location.href).searchParams.get("jwt") ? new URL(window.location.href).searchParams.get("jwt") : localStorage.getItem("accessToken")}`
      },
      'body': json ? JSON.stringify(body) : body
    }).then(res => {
      if (res.status == 200) alert && enqueueSnackbar("Sukces!", { variant: "success" })
      else if (res.status == 401) {
        localStorage.clear('accessToken');
        window.location.href = '/';
      }
      else if (res.status == 404) (enqueueSnackbar("Nie znaleziono!", { variant: "error" }));
      else if (![406, 409].includes(res.status)) throw (enqueueSnackbar("Błąd!", { variant: "error" }));//If status 406 or 409 doesn't throws error and displays server_dialog
      return res.json();
    }).then(res => {
      if (res.server_dialog) throw (enqueueSnackbar(res.server_dialog, { variant: "warning" }));
      prom(res);
    })
  })
};

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export const TokenData = React.createContext();

const routesList = [
  { path: '/clients', element: Clients },
  { path: '/traders', element: Traders },
  { path: '/users', element: Users },
]

function App() {
  const theme = createTheme({
    plPL,
    coreplPL
  });

  const token = localStorage.getItem("accessToken") ? localStorage.getItem("accessToken") : new URL(window.location.href).searchParams.get("jwt");
  if (!token) return (<ThemeProvider theme={theme}><Login /></ThemeProvider>);
  const tokenData = parseJwt(token);

  console.log(tokenData);
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <TokenData.Provider value={tokenData}>
          <Header />
          <MainContent>
            <Routes>
              <Route path="/" element={<div>
                Test
              </div>} />
              {
                routesList.map((e, index) => <React.Fragment key={`routesGroup${index}`}>
                  <Route path={e.path} element={<e.element />}></Route>
                  <Route path={`${e.path}/add`} element={<e.element add={true} />}></Route>
                  <Route path={`${e.path}/:lookupId/edit`} element={<e.element />}></Route>
                  <Route path={`${e.path}/:lookupId/lookup`} element={<e.element disableEdit={true} />}></Route>
                </React.Fragment>)
              }
              <Route path="/orders" element={<Orders />} />
              <Route path="/production" element={<Production />} />
              <Route path="/warehouse" element={<Warehouse />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/archive/:lookupId/lookup" element={<Orders disableEdit={true} archive={true} />} />
              <Route path="/orders/add/:clientId" element={<Orders add={true} />} />
              <Route path="/orders/:lookupId/edit" element={<Orders />} />
              <Route path="/orders/:lookupId/lookup" element={<Orders disableEdit={true} />} />
              <Route path="/orders/:orderId/manage" element={<OrderManage />} />
              <Route path="/orders/files" element={<FilesChecking />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/*" element={<div>404</div>} />
            </Routes>
          </MainContent>
        </TokenData.Provider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
